import { ENV_PRODUCTION, ENV_STAGE, ENV_TEST } from '@vfde-fe/sails_core';
import { SalesChannel } from './enum';
import {
    DOMAIN_DEVELOPMENT,
    DOMAIN_TEST,
    DOMAIN_PRODUCTION,
    DOMAIN_STAGE,
} from '@vfde-fe/sails-constants';

/**
 * Classnames
 */
export const CLASSNAME_VISUALLY_HIDDEN = 'brix-is-visually-hidden';
export const CLASSNAME_IMAGE_TEXT_IMAGE = 'brix-image-text__image';
export const CLASSNAME_FOOTNOTE_LINKS = 'brix-footnote-link-style';
export const CLASSNAME_SR_ONLY = 'brix-sr-only';

/**
 * HTML wrapper ids
 */
export const WRAPPER_ID_YOUNG_SWITCH = 'gigacube-form-switch';
export const WRAPPER_ID_IMAGE_HEADER = 'image-header-container';
export const WRAPPER_ID_IMAGE_TEXT = 'gigacube-image-text';
export const WRAPPER_ID_ADDITIONAL_LINKS = 'gigacube-vertical-additional-links';
export const WRAPPER_ID_LOADING_SPINNER = 'gigacube-loading-spinner';
export const WRAPPER_ID_FAQ_ACCORDION = 'fixnet-faq-accordion';
export const WRAPPER_ID_PRODUCT_TEXT_LINK = 'gigacube-product-text-link';

// offer price component
export const WRAPPER_ID_OFFER_PRICE = 'gigacube-offer-price';
export const WRAPPER_ID_SELECTED_TARIFF_HEADLINE = 'gigacube-selected-tariff-headline';
export const WRAPPER_ID_PROMO_PRICE = 'gigacube-promo-price';
export const WRAPPER_ID_TARIFF_STAIRWAY = 'gigacube-tariff-stairway';
export const WRAPPER_ID_TARIFF_LEGAL = 'gigacube-tariff-legal';
export const WRAPPER_ID_OFFER_PRICE_BUTTON = 'gigacube-offer-price__button';

// Components used in the content part
export const WRAPPER_ID_TABS = 'data-volume-tabs';

/**
 * API and query
 */
export const API_DEV_URL = 'https://dxl.preprod.api.vodafone.de/glados/v2/tariff/v1/hardware';
export const API_DEV_KEY = 'c6gNL9WA2tAeRdVPKUL6G70MFXdtEZeR';
export const API_URL = 'https://api.vodafone.de/glados/v2/tariff/v1/hardware';
export const API_KEY = 'P3S9N5IZGzyUEk5WeUbdpotzZJ64jDrS';
export const SESSION_KEY = 'state';
export const QUERY_PARAM_YOUNG = 'young';
export const QUERY_PARAM_TARIFF = 'tariffId';
export const QUERY_PARAM_DEVICE = 'deviceId';

/**
 * F&F validation
 */
export const FNF_VALIDATION_URL = 'https://eweb8.vfd2-testnet.de/api/vfd2dyn/json/family-friends/ffhashcheckforcube.php';
export const FNF_ERROR_PAGE_URL = 'https://eweb8.vfd2-testnet.de/tellyourfriend/familyandfriends_info.html';
export const FNF_URL_PARAM = 'ffgc';
export const FNF_VALIDATION_PARAM = 'h';
export const FNF_COOKIE_NAME = 'vfhvaluefafc';

// common
export const KEY = 'VF-ZP';
export const OVERLAY = 'overlay';
export const ACCORDION = 'accordion';

export const SALECSCHANNEL_MAP = {
    [SalesChannel.CONSUMER]: 'consumer',
    [SalesChannel.YOUNG]: 'young',
    [SalesChannel.FF]: 'familyfriends',
};

export const ENV_MAP = {
    [DOMAIN_PRODUCTION]: ENV_PRODUCTION,
    [DOMAIN_TEST]: ENV_TEST,
    [DOMAIN_DEVELOPMENT]: ENV_TEST,
    [DOMAIN_STAGE]: ENV_STAGE,
};

export const TRACKING_FLOW_TYPE = 'gigacube hub consumer';
export const TRACKING_PRODUCT_LINE = 'data';
export const TRACKING_TYPE_INFORMATION = 'information';
export const TRACKING_APPLIED_FILTERS = { facet: 'promotion', value: 'none' };
export const TRACKING_ERROR_NOTIFICATION = 'error';
export const TRACKING_ERROR_ACTION = 'displayed';
export const TRACKING_ERROR_AREA = 'availability';
